/* Wall-art PDP: visual strike-through pricing (controlled from darphane).
 *
 * Reads window.WallArtSale = { active, percent, codePercent } (rendered by
 * main-product.liquid from shop metafields) and keeps two things in sync with
 * the live price as the wall-art picker changes format/size:
 *
 *   1. Campaign strike (only when active): an inflated "original" price next
 *      to the real price = actual ÷ (1 − percent/100), rounded UP to a .99
 *      ending. The real price is the constant and is never touched.
 *
 *   2. Get-code price (whenever the offer banner shows): a further
 *      −codePercent off the actual price, shown as ~~actual~~ discounted.
 *
 * The visible price on a wall-art product lives in the `wall-art-price-atc`
 * widget ([data-wallart-atc-price]) — the standalone #price block is hidden.
 * So we inject the strike next to THAT price (and its scroll-mirror clone).
 * For non-wall-art products we fall back to the server-rendered strike inside
 * #price. Purely cosmetic — no real prices/discounts involved. */
(function () {
  if (window.__waSalePricingInit) return;
  window.__waSalePricingInit = true;

  var cfg = window.WallArtSale || {};
  var pct = Math.max(0, Math.min(95, Number(cfg.percent) || 0));
  var codePct = Math.max(0, Math.min(95, Number(cfg.codePercent) || 10)) || 10;
  var saleActive = !!cfg.active && pct > 0;

  function to99(x) { return Math.ceil(x - 0.99 - 1e-6) + 0.99; }   // round UP to .99
  function round2(x) { return Math.round(x * 100) / 100; }
  function parseAmt(t) { var m = (t || '').match(/[\d.,]+/); return m ? parseFloat(m[0].replace(/,/g, '')) : NaN; }

  // Format `amount` using the prefix/suffix (currency symbol / code) of a
  // sample price string, en-US grouping + 2 decimals.
  function fmt(sample, amount) {
    var s = (sample || '').trim();
    var m = s.match(/[\d.,]+/);
    var num = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (!m) return '$' + num;
    var i = s.indexOf(m[0]);
    return s.slice(0, i) + num + s.slice(i + m[0].length);
  }

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var getcodeWrap = document.querySelector('[data-wa-getcode]');
    var getcodeWas = getcodeWrap && getcodeWrap.querySelector('[data-wa-getcode-was]');
    var getcodeNow = getcodeWrap && getcodeWrap.querySelector('[data-wa-getcode-now]');

    // The visible price: the wall-art ATC widget, else the (standard) price block.
    function primaryPriceText() {
      var el = document.querySelector('[data-wallart-atc-price]')
        || info.querySelector('[id^="price-"] .price-item--regular')
        || info.querySelector('.price-item--regular');
      return el ? el.textContent : '';
    }

    function setStrikeAfter(priceEl, Y) {
      var block = priceEl.parentElement;
      if (!block) return;
      var s = block.querySelector('[data-wa-atc-strike]');
      if (!s) {
        s = document.createElement('s');
        s.className = 'wa-atc-strike';
        s.setAttribute('data-wa-atc-strike', '');
        s.setAttribute('aria-hidden', 'true');
        priceEl.insertAdjacentElement('afterend', s);
      }
      var xText = fmt(priceEl.textContent || '', to99(Y / (1 - pct / 100)));
      if (s.textContent !== xText) s.textContent = xText;
    }

    function recompute() {
      var sample = primaryPriceText();
      var Y = parseAmt(sample);
      if (!isFinite(Y) || Y <= 0) return;

      if (saleActive) {
        // "Sale Ends H:MM:SS" timer next to the price — reveal only during an
        // active campaign (sale-countdown.js fills the clock; the span sits
        // right after the strike). Force an immediate fill to avoid a flash.
        var saleEnds = document.querySelectorAll('[data-wa-sale-ends]');
        for (var se = 0; se < saleEnds.length; se++) {
          if (saleEnds[se].hasAttribute('hidden')) saleEnds[se].removeAttribute('hidden');
        }
        if (saleEnds.length && window.YukiSaleCountdown) window.YukiSaleCountdown.refresh();
        // Wall-art ATC price(s) — primary row + the scroll-mirror clone.
        var atcPrices = document.querySelectorAll('[data-wallart-atc-price]');
        for (var i = 0; i < atcPrices.length; i++) {
          var py = parseAmt(atcPrices[i].textContent);
          setStrikeAfter(atcPrices[i], isFinite(py) && py > 0 ? py : Y);
        }
        // Standard products: the server-rendered strike inside #price.
        var legacy = info.querySelector('[data-wa-price-strike]');
        if (legacy) {
          var lText = fmt(sample, to99(Y / (1 - pct / 100)));
          if (legacy.textContent !== lText) legacy.textContent = lText;
        }
        // Sale campaign banner: actual price + struck "original".
        var camp = document.querySelector('[data-wa-campaign-prices]');
        if (camp) {
          var cp = camp.querySelector('[data-wa-campaign-price]');
          var cs = camp.querySelector('[data-wa-campaign-strike]');
          if (cp) { var pText = fmt(sample, Y); if (cp.textContent !== pText) cp.textContent = pText; }
          if (cs) { var sText = fmt(sample, to99(Y / (1 - pct / 100))); if (cs.textContent !== sText) cs.textContent = sText; }
          if (camp.hasAttribute('hidden')) camp.removeAttribute('hidden');
        }
      }

      if (getcodeWrap && getcodeWas && getcodeNow) {
        var nowText = fmt(sample, round2(Y * (1 - codePct / 100)));
        if (getcodeNow.textContent !== nowText) {
          getcodeWas.textContent = fmt(sample, Y);
          getcodeNow.textContent = nowText;
        }
        if (getcodeWrap.hasAttribute('hidden')) getcodeWrap.removeAttribute('hidden');
      }
    }

    recompute();

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(recompute);
      var watched = [];
      function watch(el) {
        if (el && watched.indexOf(el) < 0) {
          watched.push(el);
          obs.observe(el, { childList: true, subtree: true, characterData: true });
        }
      }
      document.querySelectorAll('[data-wallart-atc-price]').forEach(watch);
      var pb = info.querySelector('[id^="price-"]');
      if (pb) watch(pb);
      // The scroll-mirror ATC row is cloned at load — re-scan + recompute then.
      window.addEventListener('load', function () {
        document.querySelectorAll('[data-wallart-atc-price]').forEach(watch);
        recompute();
      });
    }
    // Picker fires this on every selection change (belt + suspenders).
    document.addEventListener('wallart:selection:changed', recompute);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
